import { isolate } from '@batiflow/ui';
import { Button, __css, tokens } from '@fluentui/react-components';
import { Link20Regular } from '@fluentui/react-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LinksList } from './links-list';
import { ShareLinkDialog } from './share-dialog';

const useStyles = __css({"section":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1wn3y0l"},"head":{"mc9l5x":"f22iagw","Eh141a":"fni485r","Bt984gj":"f122n59","Brf1p80":"f1869bpl","i8kkvl":"fsnqrgy","Belr9w4":"f778t4r"},"heading":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Be2twd7":"fkhj508","Bg96gwp":"f1i3iumi","Bhrd7zp":"fl43uef","sj55zd":"f19n0e5"}});

export interface ShareLinksSectionProps {
  spaceId: string;
  document: { id: string; title: string };
  /** The caller manages the space: the section is shown (the API answers 404 to anyone else). */
  canShare: boolean;
}

/** The share links of a document, in its panel (GEDX-FE-03): the list and "Partager par lien". */
export function ShareLinksSection({ spaceId, document, canShare }: ShareLinksSectionProps) {
  const { t } = useTranslation('shareLinks');
  const styles = useStyles();
  const [sharing, setSharing] = useState(false);
  if (!canShare) return null;
  const target = { type: 'document', id: document.id, name: document.title } as const;
  return (
    <section className={styles.section} aria-labelledby="share-links-title">
      <div className={styles.head}>
        <h3 id="share-links-title" className={styles.heading}>
          {t('section.title')}
        </h3>
        <Button
          size="small"
          icon={<Link20Regular />}
          aria-label={t('action.openFor', { name: isolate(document.title) })}
          onClick={() => {
            setSharing(true);
          }}
        >
          {t('action.open')}
        </Button>
      </div>
      <LinksList
        spaceId={spaceId}
        target={target}
        label={t('list.label')}
        emptyText={t('section.empty')}
      />
      {sharing ? (
        <ShareLinkDialog
          spaceId={spaceId}
          target={target}
          onClose={() => {
            setSharing(false);
          }}
        />
      ) : null}
    </section>
  );
}


import "/opt/batiflow/app/apps/web/src/features/share-links/share-section.griffel.css";